export const ele = {
    /* ele.path(elementNode)
    * Gets an array of the element's path hierarchy, similar to Event.prototype.composedPath()
    * except without needing an Event. This supports traversing 'meta nodes'
    * such as #shadow-root, #document-fragement, and #text.
    * Results in an array with each normal (not 'meta') element's tagName||nodeName in lower-case.
    * The array does NOT include the initial element's name.
    * eg: ['thisElementsParent', 'thisElementsParentsParent', ...]
    * An empty array will be returned if no parents exist.
    */
    path(elementNode) {
        let path = [],
            node = elementNode.parentNode;

        while (node) {
            let name = node.tagName || node.nodeName;
            name = name && name.toLowerCase();

            if (!name || name.startsWith('#')) // #document-fragment, #shadow-root, #text etc
                node = node.host;
            else { // otherwise 'normal' element, add to path array and continue with parent
                path.push(name);
                node = node.parentNode;
            }
        }

        return path;
    }
};